var _rect, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBirdHouseBlackWithBird(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 680,
    height: 800,
    viewBox: "0 0 680 800",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(340 400)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 800,
    x: -340,
    y: -400,
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeWidth: 1,
    opacity: 1,
    rx: 0,
    ry: 0,
    vectorEffect: "non-scaling-stroke",
    visibility: "hidden"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.23 0 0 3.23 336.22 197.57)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#B77900",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0,
    d: "M-100 59V41L0-59 100 41v18L0-41-100 59z",
    opacity: 1,
    vectorEffect: "non-scaling-stroke"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.23 0 0 3.23 336.73 425.79)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6e6e6e",
    fillRule: "evenodd",
    stroke: "#000",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 1,
    d: "M79-32.5v144H-79v-144l79-79z",
    opacity: 1,
    vectorEffect: "non-scaling-stroke"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.95 0 0 4.26 348.83 708.92)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    fill: "#000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0,
    opacity: 1,
    rx: 3.955,
    ry: 3.671,
    vectorEffect: "non-scaling-stroke"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(12.25 0 0 13.2 339.05 374.84)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    fill: "#FFF",
    fillRule: "evenodd",
    stroke: "#000",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    strokeWidth: 0,
    opacity: 1,
    rx: 3.955,
    ry: 3.671,
    vectorEffect: "non-scaling-stroke"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(322.25 575.19)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -8.11)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#016ED2",
    fillRule: "nonzero",
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeWidth: 1,
    d: "M264 52h-34.17c-.76-1.6-1.58-3.16-2.49-4.67-14.683-25.193-46.242-34.903-72.548-22.32-26.305 12.584-38.552 43.247-28.152 70.49L23.81 198.25 8 214.14l11.19 11.18 29.28-7.8c45.01 27.015 101.947 23.832 143.666-8.031C233.854 177.626 251.908 123.533 237.69 73z",
    opacity: 1,
    transform: "translate(-136 -127.65)",
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.94 96.24)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.01,
    height: 40,
    x: -4.005,
    y: -20,
    fill: "#016ED2",
    fillRule: "nonzero",
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeWidth: 1,
    opacity: 1,
    rx: 0,
    ry: 0,
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.91 96.24)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.01,
    height: 40,
    x: -4.005,
    y: -20,
    fill: "#016ED2",
    fillRule: "nonzero",
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeWidth: 1,
    opacity: 1,
    rx: 0,
    ry: 0,
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.94 -79.76)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    fill: "#016ED2",
    fillRule: "nonzero",
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeWidth: 1,
    opacity: 1,
    rx: 12.01,
    ry: 12,
    vectorEffect: "non-scaling-stroke"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdHouseBlackWithBird);
export default __webpack_public_path__ + "static/media/bird-house-black-with-bird.ac6cfb8fbc17addf75f0e7bc4b409de4.svg";
export { ForwardRef as ReactComponent };